import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { isValidUrl } from '@intigral/utils';
import useLanguage from '../../../hooks/useLanguage';
import { BannerContent, BannerProps } from '../types/iBanner.types';
import { __ } from '../../../translations';
// import { MixpanelContext } from '../../../contexts/MixpanelContext';
// import { EVENT } from '../constants/mixpanel';

const useBannerActions = (carousel: BannerProps['carousel']) => {
    // Hooks
    const language = useLanguage();
    const navigate = useNavigate();
    // const { track } = useContext(MixpanelContext);

    // Banner Content
    const bannerContent: BannerContent = carousel?.data?.contentV3?.[0] || carousel?.data?.content?.[0];
    const menuItemId = bannerContent?.menuItemId ?? '';
    const imageUrl = bannerContent?.imageUrls?.[0]?.[language === 'en' ? 'url' : 'urlAr'] ?? '';
    const externalLink = bannerContent?.externalLink ?? '';
    // Click Handler
    const onClickHandler = useCallback(() => {
        if (externalLink) {
            if (isValidUrl(__(externalLink))) {
                window.open(__(externalLink), '_blank');
            }
            return;
        }
        navigate(menuItemId ? `/${language}/${menuItemId}` : '/');
        // Mixpanel tracking
        // track(EVENT.MLP.MLP_BANNER_CLICKED, {
        //     'Screen Name': 'Home screen',
        // });
    }, [navigate, language, menuItemId, externalLink]);

    // Return values
    return {
        onClickHandler,
        image: imageUrl,
    };
};

export default useBannerActions;
